//@ts-nocheck
import isEqual from "lodash.isequal";
import { arrayToString, toTitleCase } from "../../utils/functions";

function getClassGroup(classArr) {
  const classGroups = {
    Nursery: ["Preschool", "Nursery 1", "Nursery 2"],
    "Lower Primary": ["Primary 1", "Primary 2", "Primary 3"],
    "Upper Primary": ["Primary 4", "Primary 5", "Primary 6"],
    "Junior Secondary": ["JSS 1", "JSS 2", "JSS 3"],
    "Senior Secondary": ["SSS 1", "SSS 2", "SSS 3"],
  };
  let result = [];
  classArr.forEach((klass) => {
    let foundGroup = Object.values(classGroups).find((group) =>
      group.includes(klass),
    );
    result.push(foundGroup);
  });
  let output = result.map((item) =>
    Object.keys(classGroups).find((key) => isEqual(classGroups[key], item)),
  );
  return Array.from(new Set(output));
}

export const setNumberOfHours = (hours) => {
  if (hours === 1) return 1.2;
  if (hours === 1.5) return 1.6;
  if (hours === 4) return 3.7;
  if (hours === 5) return 4.5;
  if (hours === 6) return 5;
  return hours;
};

export function getScheduleFactors(requestData, searchObj) {
  let lessonSchedule =
    searchObj?.lessonDetails ||
    requestData?.lessonDetails?.lessonSchedule ||
    {};

  return {
    lessonDuration: lessonSchedule.lessonDuration,
    lessonHours: lessonSchedule.lessonHours,
    lessonDays: searchObj?.lessonDays?.length || 0,
    numberOfStudents: searchObj?.names?.length || 0,
  };
}
export function toLessonInfoFormat(
  { lessonPayments, totalLessons, totalTuition },
  splitRequests,
) {
  let tutorsLessonInfo = lessonPayments.map((tutorInfo, i) => {
    return {
      ...tutorInfo.tutor,
      subjects: splitRequests[i].subjectGroup,
      lessons: tutorInfo.lessons,
      students: tutorInfo.students,
      lessonFee: tutorInfo.lessonFee,
    };
  });
  return {
    selectedTutors: tutorsLessonInfo,
    numberOfLessons: totalLessons,
    lessonAmount: totalTuition,
  };
}
export function rawTotalPrice(
  hourlyRate,
  extraStdDiscount = 0,
  { lessonDays, lessonDuration, lessonHours, numberOfStudents },
) {
  let { amount } = determineTutorTotalPrice(
    { subject: { hourlyRate, discountForExtraStudents: extraStdDiscount } },
    {
      lessonDays,
      lessonDuration,
      lessonHours,
      numberOfStudents,
    },
  );
  return amount;
}
export function determineTutorTotalPrice(
  tutorData,
  { lessonDays, lessonDuration, lessonHours, numberOfStudents },
  isAdmin?: boolean,
) {
  let hourlyRate = tutorData?.subject?.hourlyRate || 0;
  let extraStdDiscount =
    100 - (tutorData?.subject?.discountForExtraStudents || 0);
  if (extraStdDiscount === 0) {
    extraStdDiscount = 25;
  }
  let hoursPerLesson = setNumberOfHours(lessonHours);
  let numberOfLessons = lessonDays * lessonDuration;
  let scheduleIsSet = lessonDuration && hoursPerLesson && lessonDays;
  let tuitionPerStudent = hourlyRate;

  if (scheduleIsSet)
    tuitionPerStudent = hourlyRate * hoursPerLesson * numberOfLessons;

  let totalTuition =
    tuitionPerStudent * (1 + (extraStdDiscount / 100) * (numberOfStudents - 1));

  let chargePerLesson = hourlyRate * hoursPerLesson;

  let extraStudentTuition =
    tuitionPerStudent * (extraStdDiscount / 100) * (numberOfStudents - 1);

  return {
    scheduleIsSet,
    lessons: numberOfStudents > 0 ? numberOfLessons : 0,
    amount: totalTuition,
    extraStudentTuition,
    tuitionPerStudent,
    students: numberOfStudents,
    chargePerLesson,
  };
}

export function getTutorPrice(tutorData, requestData, searchObj) {
  let { lessonDays, lessonDuration, lessonHours, numberOfStudents } =
    getScheduleFactors(requestData, searchObj);
  let result = determineTutorTotalPrice(tutorData, {
    lessonDays,
    lessonDuration,
    lessonHours,
    numberOfStudents,
  });
  return result;
}

export function interpretTutorData(
  tutorData = {},
  requestData = {
    lessonDetails: {
      lessonSchedule: {
        lessonDuration: 0,
        lessonHours: 0,
        lessonDays: [],
      },
    },
    contactDetails: {},
  },
  searchObj = {},
) {
  const {
    subject,
    subjectList = [],
    level,
    firstName,
    education,
    delivery,
    rating,
    gender,
    workHistory,
    classesTaught = [],
    entranceSchools = [],
    examsExperience = [],
    activeBookings,
    specialNeedExpertise,
    curriculum,
    testimonials: oldTestimonials,
    transformedTestimonials,
  }: any = tutorData;
  const testimonials = transformedTestimonials || oldTestimonials;
  const {
    purposes = [],
    specialNeeds: _specialNeeds = [],
    curriculum: requestedCurriculum = [],
  }: any = searchObj;
  let {
    lessonDetails: { lessonSchedule },
    contactDetails: { country },
  }: any = requestData;

  let { lessonDuration } = lessonSchedule;

  let isPremium = level === "premium";
  let isMale = gender === "male";
  // let relevantSubjects = [...new Set([subject.name, ...subject.related])];
  let related = subject.related || [];
  let relevantSubjects = Array.from(new Set(related));

  let earlyChildPurposes = ["Early Child Education", "Lower Primary Education"];

  let earlyChildFunc = () => {
    let uniquePurposes: any = [...new Set(purposes)];

    if (uniquePurposes.length <= 2)
      return uniquePurposes.every((purpose) =>
        earlyChildPurposes.includes(purpose),
      );

    return false;
  };

  let earlyChildCurriculum = ["Montessori", "EYFS"];
  let earlyChildSubjects = [
    "Literacy & Numeracy",
    "Phonics",
    "Handwriting",
    // "Creative Writing",
  ];

  let hasEarlyChildSubjects = earlyChildSubjects.every((subject) =>
    subjectList.includes(subject),
  );

  let isEarlyChildRequest = earlyChildFunc();
  let specialNeeds = _specialNeeds.filter((need) => need !== "None");
  let isSpecialNeedsRequest = specialNeeds.length > 0;
  let isMatchingCurriculum = requestedCurriculum.every((curr) =>
    curriculum.includes(curr),
  );
  let isIndemand = activeBookings.length > 1;

  let earlyChildArray = curriculum.filter((curr) =>
    earlyChildCurriculum.includes(curr),
  );

  const tutorBadges = {
    isEarlyChild: "Early Childhood",
    isEntrance: "Entrance Prep",
    isCambridge: "Cambridge Prep",
    isPlacement: "Placement Exam",
    isCertificate: "Exam Prep",
  };

  const entrancePurposes = [
    "Common Entrance Exam",
    "Entrance Into Top Schools",
    "11+ Entrance Exam",
    "Cambridge Primary Exam",
  ];
  const cambridgePurposes = [
    "IGCSE - Cambridge A/Levels",
    "Cambridge Checkpoint",
  ];
  const cambridgeShortName = ["IGCSE", "Checkpoints"];
  const placementPurposes = [
    "SAT / PSAT - Reasoning Test",
    "ACT - College Test",
    "AP - Advanced Placement Exam",
    "SAT II - Subject Tests",
  ];
  const certificatePurposes = [
    "JSSCE / BECE",
    "WAEC / JAMB / NECO / JUPEB",
    "Edexcel - International A/Levels",
    "IB - International Baccalaureate",
  ];
  const shortenPurposes = (word) => {
    if (word === placementPurposes[0]) return "SAT / PSAT";
    if (word === placementPurposes[1]) return "ACT";
    if (word === placementPurposes[3]) return "AP";
    if (word === certificatePurposes[0]) return "JSSCE";
    if (word === certificatePurposes[1]) return "WAEC / UME";
    if (word === certificatePurposes[2]) return "Edexcel";
    if (word === certificatePurposes[3]) return "IB";
    return "";
  };

  let isEntrance =
    entrancePurposes.some((purpose) => purposes.includes(purpose)) &&
    entranceSchools.length > 0;
  let isEarlyChild =
    hasEarlyChildSubjects && isEarlyChildRequest && earlyChildArray.length > 0;
  let isSpecial = isSpecialNeedsRequest && specialNeedExpertise.length > 0;
  let isCambridge = cambridgePurposes.some(
    (purpose) =>
      purposes.includes(purpose) &&
      cambridgePurposes.some((purpose) => examsExperience.includes(purpose)),
  );
  let isPlacement = placementPurposes.some(
    (purpose) =>
      purposes.includes(purpose) &&
      placementPurposes.some((purpose) => examsExperience.includes(purpose)),
  );
  let isCertificate = certificatePurposes.some(
    (purpose) =>
      purposes.includes(purpose) &&
      certificatePurposes.some((purpose) => examsExperience.includes(purpose)),
  );

  const getBadge = () => {
    if (isEarlyChild) return tutorBadges.isEarlyChild;
    if (isEntrance) return tutorBadges.isEntrance;
    if (isCambridge) return tutorBadges.isCambridge;
    if (isPlacement) return tutorBadges.isPlacement;
    if (isCertificate) return tutorBadges.isCertificate;
    return false;
  };

  const generateBadges = () => {
    let badges = [];
    if (getBadge()) badges = [...badges, getBadge()];
    return badges;
  };

  const getMainBadge = () => {
    let result = {
      isEarlyChild: false,
      isEntrance: false,
      isCambridge: false,
      isPlacement: false,
      isCertificate: false,
    };
    if (getBadge()) {
      let badgeKeys = Object.keys(tutorBadges);
      let badgeValues: any = Object.values(tutorBadges);
      let badgeIndex = badgeValues.indexOf(getBadge());
      let mainBadge = badgeKeys[badgeIndex];

      result[mainBadge] = true;
      return result;
    }

    return result;
  };

  // Orders Education and WorkHistory by End Year
  const orderCredentials = (_credentials = []) => {
    let credentials = _credentials || [];
    let currentCredentials = credentials.filter(
      (credential) => credential.isCurrent,
    );
    let remainingCredentials = credentials
      .filter((credential) => !currentCredentials.includes(credential))
      .sort((a, b) => b.endYear - a.endYear);

    return [...currentCredentials, ...remainingCredentials];
  };

  const getYearsOfExperience = (work) => {
    let initialValue = 0;
    let teachingHistory = work.filter(({ isTeachingRole }) =>
      Boolean(isTeachingRole),
    );
    const reducer = (accumulator, currentValue) => {
      let experience = currentValue.isCurrent
        ? new Date().getFullYear() - currentValue.startYear
        : currentValue.endYear - currentValue.startYear;

      return accumulator + experience + 1;
    };
    return teachingHistory.reduce(reducer, initialValue);
  };

  const orderTestimonials = () => {
    return [...testimonials].sort((a, b) => {
      let dateA: any = new Date(a.dateReviewed),
        dateB: any = new Date(b.dateReviewed);
      return dateB - dateA;
    });
  };

  const formatSchools = entranceSchools.map((schools) =>
    toTitleCase(schools.toLowerCase()),
  );

  const cambridgePrep = examsExperience
    .filter((exam) => cambridgePurposes.includes(exam))
    .map((exam) => {
      if (exam === cambridgePurposes[0]) return cambridgeShortName[0];
      return cambridgeShortName[1];
    });

  const placementExams = examsExperience
    .filter((exam) => placementPurposes.includes(exam))
    .map((exam) => shortenPurposes(exam));

  const certificateExams = examsExperience
    .filter((exam) => certificatePurposes.includes(exam))
    .map((exam) => shortenPurposes(exam));

  const generateSummary = () => {
    let summary = [];

    const summaryData = {
      entrance: {
        title: "Entrance exam expert",
        icon: "exam",
        description: `${firstName} has helped students get into ${arrayToString(
          formatSchools,
        )}`,
      },
      earlyYears: {
        title: "Great with kids",
        icon: "guarantee",
        description: `Earlychild educator experienced in the ${arrayToString(
          earlyChildArray,
        )} curriculum.`,
      },
      examPrep: {
        title: "Exam preparation expert",
        icon: "exam",
        description: `Prepares students for ${arrayToString(examsExperience)}.`,
      },
      specialNeeds: {
        title: "Works with special needs",
        icon: "special-needs",
        description: `Experienced handling kids living with ${arrayToString(
          specialNeedExpertise,
        )}.`,
      },
      premium: {
        title: `${firstName} is a Premium tutor`,
        icon: "premium",
        description:
          "Premium tutors are exceptional, highly-rated tutors who have consistently delivered the best results and learning experience with clients.",
      },
      topRated: {
        title: `${firstName} is a Top-rated tutor`,
        icon: "premium",
        description:
          "Top-rated tutors have received great reviews from clients and have a trackrecord of producing outstanding results.",
      },
      curriculum: {
        title: "Curriculum experience",
        icon: "homework",
        description: `Teaches with the ${arrayToString(
          curriculum,
        )} curriculum.`,
      },
      matchingCurriculum: {
        title: "Matching curriculum",
        icon: "homework",
        description: `Teaches with the ${arrayToString(
          curriculum,
        )} curriculum.`,
      },
      indemand: {
        title: "In high demand",
        icon: "fire-outline",
        description: `This tutor is usually fully booked, but currently has availability for one more client. Book quickly while ${
          isMale ? "he" : "she"
        } is still available.`,
      },
      onlineDelivery: {
        title: "Online lessons only",
        icon: "whiteBoard",
        description: `${firstName} only offers online, live lessons`,
      },
      offlineDelivery: {
        title: "Physical lessons only",
        icon: "whiteBoard",
        description: `${firstName} only offers physical lessons at your home or agreed location`,
      },
      onlineAndOffline: {
        title: "Physical and online lessons",
        icon: "whiteBoard",
        description: `${firstName} can deliver lessons at your home or online`,
      },
    };

    const generateExamSummary = () => {
      if (isEarlyChild) return summaryData.earlyYears;
      if (isEntrance) return summaryData.entrance;
      if (examsExperience.length > 0) return summaryData.examPrep;
      return false;
    };

    const generateSpecialNeed = () => {
      if (isSpecial) return summaryData.specialNeeds;
      return false;
    };

    const generatePremium = () => {
      if (isPremium) return summaryData.premium;
      if (!isPremium && rating >= 4.5) return summaryData.topRated;
      return false;
    };

    const generateCurriculum = () => {
      if (isMatchingCurriculum) return summaryData.matchingCurriculum;
      if (curriculum.length > 0) return summaryData.curriculum;
      return false;
    };

    const generateIndemand = () => {
      if (isIndemand) return summaryData.indemand;
      return false;
    };

    const generateLessonDelivery = () => {
      if (delivery.every((i) => i === "online")) {
        return summaryData.onlineDelivery;
      }
      if (delivery.every((i) => i === "physical")) {
        return summaryData.offlineDelivery;
      }
      return summaryData.onlineAndOffline;
    };

    if (generateExamSummary()) summary = [...summary, generateExamSummary()];
    if (generateSpecialNeed()) summary = [...summary, generateSpecialNeed()];
    if (generateCurriculum()) summary = [...summary, generateCurriculum()];
    if (generateIndemand()) summary = [...summary, generateIndemand()];
    if (generatePremium()) summary = [...summary, generatePremium()];
    if (generateLessonDelivery())
      summary = [...summary, generateLessonDelivery()];
    return summary;
  };

  const getFeaturedReview = () => {
    let reviews = orderTestimonials();
    if (reviews.length < 2) return {};

    let fiveStarReviews = reviews
      .filter(({ rating }) => rating === 5)
      .sort((a, b) => b.review.length - a.review.length);

    let fourStarReviews = reviews
      .filter(({ rating }) => rating === 4)
      .sort((a, b) => b.review.length - a.review.length);

    let reviewPool = [
      ...fiveStarReviews.slice(0, 3),
      ...fourStarReviews.slice(0, 2),
    ];

    let orderedReviewPool = reviewPool.sort((a, b) => {
      let dateA: any = new Date(a.dateReviewed),
        dateB: any = new Date(b.dateReviewed);
      return dateB - dateA;
    });

    if (orderedReviewPool.length > 0) return orderedReviewPool[0];

    return {};
  };
  return {
    badges: generateBadges(),
    price: getTutorPrice(tutorData, requestData, searchObj),
    clientCountry: country,
    isSpecial,
    earlyChildArray,
    isMonthly: lessonDuration === 4,
    relevantSubjects,
    isCertificate: getMainBadge().isCertificate,
    cambridgePrep,
    placementExams,
    certificateExams,
    isPlacement: getMainBadge().isPlacement,
    isEarlyChild: getMainBadge().isEarlyChild,
    isEntrance: getMainBadge().isEntrance,
    isCambridge: getMainBadge().isCambridge,
    isPremium,
    specialNeedExpertise,
    experience: getYearsOfExperience(workHistory),
    tutorSummary: generateSummary(),
    classGroup: getClassGroup(classesTaught),
    education: orderCredentials(education),
    workHistory: orderCredentials(workHistory),
    testimonials: orderTestimonials(),
    featuredReview: getFeaturedReview(),
  };
}

/////////////////

function getCustomPrice(
  tutorData,
  numberOfStudents,
  lessonDuration,
  lessonHours,
  lessonDays,
) {
  let hourlyRate = tutorData.subject.hourlyRate;
  let extraStdDiscount = tutorData.subject.discountForExtraStudents;
  let hoursPerLesson = setNumberOfHours(lessonHours);
  let numberOfLessons = lessonDays * lessonDuration;
  let tuitionPerStudent = hourlyRate * hoursPerLesson * numberOfLessons;

  let totalTuition =
    tuitionPerStudent * (1 + (extraStdDiscount / 100) * (numberOfStudents - 1));

  return totalTuition;
}

export function generatePricingIdeas(
  budget,
  tutorOptions = [],
  requestData = {},
  searchObj = {},
) {
  let {
    lessonDays: days,
    lessonDuration: length,
    lessonHours: hours,
    numberOfStudents: stds,
  } = getScheduleFactors(requestData, searchObj);

  function getMaxHours() {
    function reduceHours(hours) {
      if (hours >= 4) return hours - 1;
      if (hours <= 3 && hours > 1) return hours - 0.5;
      if (hours === 1) return 0;
    }

    let minHourAmount = 0;
    let options = [];
    let shouldContinue = true;
    let maxHours = hours;
    while (shouldContinue && maxHours > 0) {
      options = tutorOptions.filter(
        (tutor) =>
          getCustomPrice(tutor, stds, length, maxHours, days) <= budget,
      );

      if (options.length > 0) {
        let optionPrices = options.map((option) =>
          getCustomPrice(option, stds, length, maxHours, days),
        );
        minHourAmount =
          optionPrices.length > 0 && Math.trunc(Math.min(...optionPrices));
        shouldContinue = false;
      } else {
        maxHours = reduceHours(maxHours);
      }
    }

    return {
      isMaxhours: hours === maxHours,
      maxHours,
      minHourAmount,
      hourOptions: options.length,
    };
  }

  function getMaxDays() {
    let minDaysAmount = 0;
    let options = [];
    let shouldContinue = true;
    let maxDays = days;
    while (shouldContinue && maxDays > 0) {
      options = tutorOptions.filter(
        (tutor) =>
          getCustomPrice(tutor, stds, length, hours, maxDays) <= budget,
      );

      if (options.length > 0) {
        let optionPrices = options.map((option) =>
          getCustomPrice(option, stds, length, hours, maxDays),
        );
        minDaysAmount =
          optionPrices.length > 0 && Math.trunc(Math.min(...optionPrices));
        shouldContinue = false;
      } else {
        maxDays = maxDays - 1;
      }
    }

    return {
      isMaxDays: days === maxDays,
      maxDays,
      minDaysAmount,
      dayOptions: options.length,
    };
  }

  function getBestPricingPlan() {
    let daysPlan = getMaxDays();
    let hoursPlan = getMaxHours();
    let bestPlan: any = {
      bestOption: null,
      bestNumber: 0,
      bestPrice: 0,
      availableOptions: 0,
    };

    let budgetIsLow = daysPlan.dayOptions + hoursPlan.hourOptions === 0;
    let budgetIsOptimal = daysPlan.isMaxDays && hoursPlan.isMaxhours;

    if (!budgetIsLow && !budgetIsOptimal) {
      if (daysPlan.minDaysAmount > hoursPlan.minHourAmount)
        bestPlan = {
          ...bestPlan,
          bestOption: "lessonDays",
          bestNumber: getMaxDays().maxDays,
          bestPrice: getMaxDays().minDaysAmount,
          initialNumber: days,
          availableOptions: getMaxDays().dayOptions,
        };

      if (daysPlan.minDaysAmount <= hoursPlan.minHourAmount)
        bestPlan = {
          ...bestPlan,
          bestOption: "lessonHours",
          bestNumber: getMaxHours().maxHours,
          bestPrice: getMaxHours().minHourAmount,
          initialNumber: hours,
          availableOptions: getMaxHours().hourOptions,
        };
    }

    return { ...bestPlan, budgetIsLow, budgetIsOptimal };
  }

  return getBestPricingPlan();
}

export function determineTutorHourlyRate(
  { totalPrice, discount },
  requestData,
  searchObject,
) {
  const { lessonDays, lessonDuration, lessonHours, numberOfStudents } =
    getScheduleFactors(requestData, searchObject);
  const hoursPerLesson = setNumberOfHours(lessonHours);
  const numberOfLessons = lessonDays * lessonDuration;
  const totalLessonHours = hoursPerLesson * numberOfLessons;
  let extraStdDiscount = 100 - discount;
  if (extraStdDiscount === 0) {
    extraStdDiscount = 25;
  }
  const hourlyRatePerStudent =
    totalPrice /
    (1 + (extraStdDiscount / 100) * (numberOfStudents - 1)) /
    totalLessonHours;
  const hourlyRate = totalPrice / totalLessonHours;
  return {
    numberOfLessons,
    totalPrice,
    hourlyRate,
    hourlyRatePerStudent,
  };
}
